// Vendor imports
import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import focus from '@alpinejs/focus'
import intersect from '@alpinejs/intersect'
import breakpoint from 'alpinejs-breakpoints'
Alpine.plugin(intersect)
Alpine.plugin(breakpoint)
Alpine.plugin(collapse)
Alpine.plugin(focus)
window.Alpine = Alpine
window.AlpineBreakpointPluginBreakpointsList = [
	'xs',
	'sm',
	'md',
	'lg',
	'xl',
	'2xl',
	'3xl',
	'max',
	'wide',
]
window.Alpine.start()

// Stores (must register before Alpine.start)
import './modules/utm-tracking'

// Lazy-load Lottie player only when a lottie-player element exists on the page
if (document.querySelector('lottie-player')) {
	import("@lottiefiles/lottie-player");
} else {
	// Also watch for dynamically added lottie-player elements
	const lottieObserver = new MutationObserver((mutations, obs) => {
		if (document.querySelector('lottie-player')) {
			import("@lottiefiles/lottie-player");
			obs.disconnect();
		}
	});
	lottieObserver.observe(document.body, { childList: true, subtree: true });
}


import 'lazysizes/plugins/respimg/ls.respimg'
import 'lazysizes/plugins/parent-fit/ls.parent-fit'
import 'lazysizes'
import 'lazysizes/plugins/object-fit/ls.object-fit'

// Module imports
import './modules/carousel'
import './modules/animations'
import './modules/filters'
import './modules/svgIconSprite'
import './modules/video-fit'


document.addEventListener('DOMContentLoaded', () => {
	setTimeout(() => {
		window.dispatchEvent(new Event('resize'));
	}, 100);
});
